import React, { useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import {
  Alert,
  Container,
  InputGroup,
  FormControl,
  Button,
} from "react-bootstrap";
import HeaderComponent from "../boards/HeaderComponent";
import FooterComponent from "../boards/FooterComponent";
import api from "../../services/api";


export default function ActasSearch() {
  document.title = "Busqueda de Actas Circunstanciadas";

  const [data, setData] = useState(null);
  const [searchFolio, setSearchFolio] = useState("");
  const [error, setError] = useState("");
  const [errord, setErrord] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setSearchFolio(value);
    }
  };

  const handleFolio = async () => {
    if (!searchFolio) {
      setErrord("Ingrese un Folio");
      setTimeout(() => setErrord(""), 2000);
      return;
    }

    setError("");
    setErrord("");
    setData(null);
    setShowAlert(true);

    try {
      const response = await api.get(
        `actaFolio/info-acta/${searchFolio}`
      );
      setData(response.data);
    } catch (error) {
      const response = error.response?.data;
      if (response?.validation) {
        setError(response || "Ocurrió un error inesperado");
        setTimeout(() => {
          setError("");
        }, 2000);
      } else {
        setError(response || "Ocurrió un error inesperado");
        setTimeout(() => {
          setError("");
        }, 2000);
      }

    }
  };

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => setShowAlert(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  const renderAlert = () => {
    if (!showAlert || !data) return null;

    switch (data.idEstadoActa) {
      case 2:
        return renderEstado("apercibimiento-alert", "Apercibimiento");
      case 3:
        return renderEstado("amonestacion-alert", "Amonestación");
      case 4:
        return renderEstado(
          "pas-alert",
          "Procedimiento Administrativo Sancionador"
        );
      case 5:
        return renderEstado("dtr-alert", "Dictamen Técnico de Riesgos");
      case 6:
        return renderEstado("suspension-alert", "Suspensión");
      default:
        return null;
    }
  };

  const renderEstado = (className, texto) => (
    <Alert className={className}>
      <Alert.Heading className="text-center">
        <b className="text-white">Número de oficio:</b>
        <br />
        <b className="text-white">{data.folio}</b>
      </Alert.Heading>
      <div className="text-center">
        <b className="text-white">Estatus:</b>{" "}
        <b className="text-black">{texto}</b>
      </div>
    </Alert>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        //backgroundImage: "url(https://www.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/5/2024/12/459029599_938750401627993_9216811163148847696_n.jpg)",
       backgroundImage: "url(/background2.jpeg)",

        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat"
      }}
    >
      <HeaderComponent />


      <Container style={{ flex: 1 }}>
        <div
          className="container"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "10px",
            padding: "20px",
            marginTop: "20px",
            marginBottom: "20px",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h3 className="text-center text-contrast">Busqueda de Actas Circunstanciadas</h3>
          <p className="text-center text-contrast">
            {" "}
            <b>Ingrese el folio de seguimiento</b>
          </p>

          <div className="list row justify-content-center">
            <div className="col-md-8 mt-4">
              <InputGroup>
                <FormControl
                  placeholder="Ingrese el número de oficio"
                  value={searchFolio}
                  onChange={handleInputChange}
                />
                <Button variant="success" onClick={handleFolio}>
                  <AiOutlineSearch /> Buscar
                </Button>
              </InputGroup>
            </div>

            <div className="col-md-8 mt-3">
              {error && <Alert variant="danger">{error}</Alert>}
              {errord && <Alert variant="warning">{errord}</Alert>}
            </div>

            <div className="col-md-8 mt-3">{renderAlert()}</div>
          </div>


        </div>

      </Container >

      <FooterComponent />
    </div >
  );
}
